import { ca } from '@cian/analytics';

import { IAgentSchema, IOfferSchema, IUserSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

import { getCustomUrl, getPage, getPartner, getProduct, getUser } from '../../utils/tracking';
import { getProducts } from '../../utils/tracking/get_products';

export type TRealtorLabel = 'to_realtorCard_name' | 'to_realtorCard_qty' | 'to_realtorCard_ava';

export type TBuilderLabel =
  | 'to_developerCard_name'
  | 'to_developerCard_ready_JK'
  | 'to_developerCard_in_progress_JK'
  | 'to_developerCard_more';

export function trackClickShowPhone(
  offer: IOfferSchema,
  agent: IAgentSchema | null,
  abGroup: number,
  user: IUserSchema | null,
  kpId: number | null,
  isBot?: boolean,
) {
  const products = getProducts(agent, offer, kpId);

  ca('eventSite', {
    action: `Open_card_agent_block${isBot ? '_bot' : ''}`,
    category: 'Phones',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
    page: getPage(agent, offer),
    partner: getPartner(user, offer),
    products: [
      {
        ...products,
        variant: products.variant ? products.variant.split('/') : [],
      },
    ],
    user: getUser(user, abGroup),
  });
}

/* istanbul ignore next */
export function trackClickShowPhoneGallery(
  offer: IOfferSchema,
  agent: IAgentSchema | null,
  abGroup: number,
  user: IUserSchema | null,
  kpId: number | null,
  isBot?: boolean,
) {
  const products = getProducts(agent, offer, kpId);

  ca('eventSite', {
    action: `Open_photo_overlay`,
    category: 'Phones',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
    page: getPage(agent, offer),
    partner: getPartner(user, offer),
    products: [{ ...products, variant: products.variant ? products.variant.split('/') : [] }],
    user: getUser(user, abGroup),
  });
}

/* istanbul ignore next */
export function trackClickCallbackMe(offer: IOfferSchema, agent: IAgentSchema | null) {
  ca('event', {
    action: 'CallBack_popup_open_agent_block',
    category: 'card',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
  });
}

/* istanbul ignore next */
export function trackClickBuilder(label: TBuilderLabel) {
  ca('event', {
    action: 'to_developerCard_agent_block',
    category: 'card',
    label,
    name: 'oldevent',
  });
}

/* istanbul ignore next */
export function trackGoToCard(label: string) {
  ca('event', {
    action: 'to_realtorCard_agent_block',
    category: 'card',
    label,
    name: 'oldevent',
  });
}

/* istanbul ignore next */
export function trackFirstMessageClick(offer: IOfferSchema, agent: IAgentSchema | null) {
  const products = getProduct(offer, agent);

  ca('event', {
    action: 'send_message',
    category: 'card',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
    products: [{ ...products, variant: products.variant ? products.variant.split('/') : [] }],
  });
}

/* istanbul ignore next */
export function trackFirstMessageClick2(offer: IOfferSchema, agent: IAgentSchema | null) {
  ca('event', {
    action: 'send_message_overlay',
    category: 'card',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
  });
}

/* istanbul ignore next */
export function trackFirstMessageSent(
  agent: IAgentSchema | null,
  offer: IOfferSchema,
  user: IUserSchema | null,
  kpId: number | null,
) {
  const products = getProducts(agent, offer, kpId);

  ca('eventSite', {
    action: 'send_message',
    category: 'Message_popup',
    label: `${offer.id}${user ? `/${user.realtyUserId}` : ''}`,
    name: 'oldevent',
    products: [{ ...products, variant: products.variant ? products.variant.split('/') : [] }],
  });
}

/* istanbul ignore next */
export function trackFirstMessageShowPopup(offer: IOfferSchema, agent: IAgentSchema | null) {
  ca('event', {
    action: 'open',
    category: 'Message_popup',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
  });
}

/* istanbul ignore next */
export function trackGoToMessages() {
  ca('event', {
    action: 'go_to_messages',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}
